
//decoradores
import { Component, Vue } from "vue-property-decorator";

@Component
export default class QueEsPagina extends Vue {}
